<template>
  <div class="discount">
    <el-radio
      v-model="form.is_discount"
      label="1"
      @change="change"
    >是</el-radio>
    <el-radio
      v-model="form.is_discount"
      label="0"
      @change="change"
    >否</el-radio>
    <div v-if="form.is_discount == 1">
      <p class="discount-title">折扣方式<span class="discount-title-require">
          *
        </span></p>
      <div class="discount-item">
        <el-radio
          v-model="form.discount_type"
          :label="1"
          @change="change"
        >折扣</el-radio>
        <el-input-number
          :disabled="form.discount_type != 1"
          v-model="form.discountValue"
          placeholder=""
          @change="change"
          controls-position="right"
          :min="0"
          :max="10"
        ></el-input-number>
        <!-- <el-input
          :disabled="form.discount_type != 1"
          v-model="form.discountValue"
          type="number"
          placeholder=""
          @change="change"
        ></el-input> -->
        折
      </div>
      <div class="discount-item">
        <el-radio
          v-model="form.discount_type"
          :label="2"
          @change="change"
        >减负</el-radio>
        <el-input-number
          :disabled="form.discount_type != 2"
          v-model="form.reducetValue"
          placeholder=""
          @change="change"
          controls-position="right"
          :min="0"
          :max="1000000"
        ></el-input-number>
        <!-- <el-input
          :disabled="form.discount_type != 2"
          v-model="form.reducetValue"
          placeholder=""
          type="number"
          @change="change"
        ></el-input> -->
        元
      </div>
      <div class="discount-item">
        <el-radio
          v-model="form.discount_type"
          :label="3"
          @change="change"
        >结算</el-radio>
        <el-input-number
          :disabled="form.discount_type != 3"
          v-model="form.settlementValue"
          placeholder=""
          @change="change"
          controls-position="right"
          :min="0"
          :max="10000000"
        ></el-input-number>
        <!-- <el-input
          :disabled="form.discount_type != 3"
          v-model="form.settlementValue"
          placeholder=""
          @change="change"
          type="number"
        ></el-input> -->
        元
      </div>
    </div>
  </div>
</template>

<script>
import mixins from "./mixins";

export default {
  name: "discount",
  mixins: [mixins],
  data() {
    return {
      value: false,
      form: {
        // is_discount: 0,
        discount_type: undefined,
        discount_value: undefined,
      },
    };
  },
  methods: {
    change() {
      const { form } = this;
      if (form.discount_type === 1) {
        form.discount_value = form.discountValue;
      } else if (form.discount_type === 2) {
        form.discount_value = form.reducetValue;
      } else if (form.discount_type === 3) {
        form.discount_value = form.settlementValue;
      }
      this.answerChange(this.form);
    },
  },
};
</script>

<style lang="scss" scoped>
.discount-title {
  margin: 10px 0;
  .discount-title-require {
    color: red;
  }
}
.discount-item {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  .el-radio {
    margin-right: 15px;
  }
  .el-input {
    width: 50%;
    margin-right: 5px;
  }
}
</style>